<div
  class="fm-map-container"
  [class.fm-map-container--narrow]="(isMobileOrTablet$ | async) === false && (isReplayOpen$ | async)"
  [class.fm-map-container--manage-posted-speed]="(isMobileOrTablet$ | async) === false && (isManagePostedSpeedOpen$ | async)"
  [@overlaySidePanelOpen]="shouldOffsetForSidePanel$ | async"
>
  <ng-content></ng-content>
</div>
